module.exports = __webpack_public_path__ + "img/instagram.b3afa735.svg";